module.exports = __webpack_public_path__ + "static/media/voicemail.f7add3c6.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/voicemail.svg
// module id = 1840
// module chunks = 0